import React from 'react'

export default ({ ...props }) => (
  <svg {...props} width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M12.25 0.200012H1.05C0.4711 0.200012 0 0.671112 0 1.25001V7.55001C0 8.12891 0.4711 8.60001 1.05 8.60001H12.25C12.8289 8.60001 13.3 8.12891 13.3 7.55001V1.25001C13.3 0.671112 12.8289 0.200012 12.25 0.200012ZM12.25 0.900012C12.271 0.900012 12.2906 0.902112 12.3109 0.905612L7.0385 4.42031C6.8355 4.55541 6.4652 4.55541 6.2622 4.42031L0.9898 0.905612C1.0094 0.902112 1.0297 0.900012 1.0507 0.900012H12.2507H12.25ZM12.25 7.90001H1.05C0.8568 7.90001 0.7 7.74321 0.7 7.55001V1.55381L5.8737 5.00271C6.0914 5.14761 6.3707 5.22041 6.65 5.22041C6.9293 5.22041 7.2086 5.14761 7.4263 5.00271L12.6 1.55381V7.55001C12.6 7.74321 12.4432 7.90001 12.25 7.90001Z'
      fill='#0D0D0D'
    />
  </svg>
)
